<template>
  <base-content-page :page-title="pageTitle" :caption="pageDescription">
    <v-row justify="center" align="center" class="flex-column xmb-12">
      <div class="mb-4 font-weight-medium subtitle-1">3 ways to pay</div>
      <billing-frequency v-model="billingFrequency" />
    </v-row>

    <v-row justify="center" class="mb-12 mt-5">
      <v-col sm="1" md="8">
        <v-expansion-panels xclass="feature-expansion">
          <v-expansion-panel @click="onClickFeatureList">
            <v-expansion-panel-header color="secondary">
              <div class="text-center text-subtitle-1">All features are included in every plan</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="pt-2 mx-n5">
              <feature-summary class="mt-6" hide-cta show-all />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>

    <v-row justify="center">
      <pricing-card
        v-for="plan in plans"
        :key="plan.name"
        class="mx-4 my-6"
        :details="plan"
        :billing-frequency="billingFrequency"
      />
    </v-row>

    <v-row justify="center" dense class="mb-12">
      <v-col sm="1" md="6">
        <p class="text-caption mt-3 text-center">(1) Estimate is based off an average call duration of 2 minutes</p>
      </v-col>
    </v-row>

    <cta-btns color-sub-cta="black" x-large class="mx-auto mb-10" />
  </base-content-page>
</template>
<script>
import BaseContentPage from '@/components/BaseContentPage'
import BillingFrequency from '@/components/BillingFrequency'
import PricingCard from '@/components/PricingCard'
import plans from '@/content/pricing-plans.js'
import FeatureSummary from '@/components/FeaturesSummary'
import CtaBtns from '@/components/CtaButtons'
import GtmMixin from '@/mixins/gtm-info'

export default {
  components: {
    BaseContentPage,
    BillingFrequency,
    PricingCard,
    FeatureSummary,
    CtaBtns
  },

  mixins: [GtmMixin],

  async asyncData({ $content, params }) {
    const features = await $content('features')
      .only(['title'])
      // sort by file name
      .sortBy('slug', 'asc')
      .fetch()
    return { features }
  },

  data: () => ({
    features: [],
    pageTitle: 'Plans & Pricing for our Receptionist Services',
    pageDescription: "Various options to fit your business' budget and needs.",
    plans,
    billingFrequency: {},
    selectedPlan: 'plan-3'
  }),

  methods: {
    onClickFeatureList() {
      this.$gtm.push({ event: 'open:feature-list', ...this.gtmInfo })
    }
  },

  head() {
    return {
      title: this.pageTitle,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.pageDescription
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import '~vuetify/src/styles/styles.sass';

.feature-list {
  columns: 2;
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .feature-expansion {
    width: 65%;
  }
}
</style>
